import { useEffect, useState } from 'react';
import { fetchSrmUsers } from '../../qv4/models/shared/agentsUsersModel';
export function usePaymentsLedger(timeline) {
  const [users, setUsers] = useState([]);
  useEffect(() => { let active = true; fetchSrmUsers().then(result => { if (active) setUsers(result); }).catch(() => {}); return () => { active = false; }; }, []);
  const nameOf = actor => actor?.user_id == null ? null : users.find(user => String(user.id) === String(actor.user_id))?.fullName || 'Staff';
  return (timeline || []).map(row => ({ ...row, actorName: nameOf(row.actor) || 'Staff',
    history: Array.isArray(row.history) ? row.history.map(item => ({ ...item, actorName: nameOf(item.actor) })) : [] }));
}
